export const HELP_MENU_ID = 'helpMenu';
export const DESIGN_MENU_ID = 'designMenu';

export const helpMenuUrls = {
  GETTING_STARTED:
    'https://helpcenter.yola.com/hc/en-us/categories/360002294500-Basics-getting-started',
};
